import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'
import moment, { displayFormat } from 'helpers/moment'
import classes from './SalesLogs.scss'

const getOrders = (orders) => orders
  .filter(o => o.product && o.product.type && o.product.type.report === 'shellfish')
  .sort((a, b) => a.product.name.localeCompare(b.product.name))

export const SalesLog = (props) => {
  if (!getOrders(props.orders).length) return null

  return (
    <div className={classes.log}>
      <header className={classes.header}>
        <span className={classes.route} />
        <span className={classes.customer}>TwoXSea Shellfish Sales Log</span>
        <span className={classes.date}>{moment(props.orders[0].date).format(displayFormat)}</span>
      </header>

      <table className={classes.table}>
        <thead>
          <tr>
            <th className={classes.center} />
            <th className={classes.left}>customer</th>
            <th className={classes.center}>order</th>
            <th className={classes.left}>species</th>
            <th className={classes.center}>harvest<br />date</th>
            <th className={classes.center}>ship<br />date</th>
            <th className={cx(classes.center, classes.nowrap)}>harvest location</th>
            <th className={classes.center}>cert number</th>
          </tr>
        </thead>
        <tbody>
          {getOrders(props.orders).length && getOrders(props.orders).map(order => (
            <tr key={order.id}>
              <td className={classes.center}>{order.route.name}</td>
              <td className={classes.left}>{order.customer.name}</td>
              <td className={classes.center}>{order.qty} {order.uom.shorthand || order.uom.name}</td>
              <td className={classes.left}>{order.product.name}</td>
              <td className={classes.center} />
              <td className={classes.center} />
              <td className={classes.center} />
              <td className={classes.center} />
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

SalesLog.propTypes = {
  orders: PropTypes.array
}

export default SalesLog



// WEBPACK FOOTER //
// ./src/components/Reports/Shellfish/SalesLogs/SalesLogs.js